import { Component, OnInit } from "@angular/core";
import { DoctorDashboardService } from "src/app/services/doctor-dashboard.service/doctor-dashboard.service";

@Component({
  selector: "app-rounder-rdv",
  templateUrl: "./rounder-rdv.component.html",
  styleUrls: ["./rounder-rdv.component.css"],
})
export class RounderRdvComponent implements OnInit {
  numberCurrentRdvs: number = 100;
  numberRdvsMoisPre: number = 100;
  stroke: number = 15;
  radius: number = 70;
  semicircle: boolean = false;
  rounded: boolean = false;
  responsive: boolean = false;
  clockwise: boolean = true;
  color: string = "#45ccce";
  background: string = "#eaeaea";
  duration: number = 800;
  animation: string = "easeOutCubic";
  animationDelay: number = 0;
  animations: Array<string> = [
    "linearEase",
    "easeInQuad",
    "easeOutQuad",
    "easeInOutQuad",
    "easeInCubic",
    "easeOutCubic",
    "easeInOutCubic",
    "easeInQuart",
    "easeOutQuart",
    "easeInOutQuart",
    "easeInQuint",
    "easeOutQuint",
    "easeInOutQuint",
    "easeInSine",
    "easeOutSine",
    "easeInOutSine",
    "easeInExpo",
    "easeOutExpo",
    "easeInOutExpo",
    "easeInCirc",
    "easeOutCirc",
    "easeInOutCirc",
    "easeInElastic",
    "easeOutElastic",
    "easeInOutElastic",
    "easeInBack",
    "easeOutBack",
    "easeInOutBack",
    "easeInBounce",
    "easeOutBounce",
    "easeInOutBounce",
  ];
  gradient: boolean = false;
  realCurrent: number = 0;

  getOverlayStyle() {
    const isSemi = this.semicircle;
    const transform = (isSemi ? "" : "translateY(-50%) ") + "translateX(-50%)";

    return {
      top: isSemi ? "auto" : "50%",
      bottom: isSemi ? "5%" : "auto",
      left: "50%",
      transform,
      "font-size": this.radius / 3.5 + "px",
    };
  }
  constructor(private doctorDashboardService: DoctorDashboardService) { }

  ngOnInit(): void {
    this.getProgressRdvs();
  }
  dateMoisPrescrend(): number {
    const dateActuelle = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const dateFinSemaine = new Date(dateActuelle);
    const startDate = dateFinSemaine.setTime(dateFinSemaine.setMonth(dateActuelle.getMonth() - 1));
    const debutMois = new Date(startDate);
    const deboutMoisPresc = new Date(debutMois.getFullYear(), debutMois.getMonth(), 1).getTime();
    return deboutMoisPresc;
  }
  dateMoisActuel(): number {
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime();

    return endDate;
  }
  getProgressRdvs() {
    const curentMois = this.dateMoisActuel();
    const moisPres = this.dateMoisPrescrend();
    this.doctorDashboardService.projectionRDVs(moisPres, curentMois).subscribe((res) => {
      let rdvs = res;
      this.numberCurrentRdvs = rdvs[0].pCount;
      rdvs[1] == undefined ? this.numberRdvsMoisPre = 0 : this.numberRdvsMoisPre = rdvs[1].pCount;
    });
  }
}
